module.exports = __webpack_public_path__ + "img/bao.77273b3c.png";